
import { Link } from 'react-router-dom';
import { getCategories } from '../../../api/apiServices';
import { useEffect } from 'react';
import { slugify } from '../../../utils/slugify';

export default function CategorySection() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await getCategories();
        setCategories(res.data);
      } catch (error) {
        console.error("Failed to load categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <section className="py-12">
  <div className="text-center mb-10">
    <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-gray-800 mb-3">
      Shop by Category
    </h2>
    <p className="text-gray-500 font-['Poppins'] text-sm">
      Find your perfect style
    </p>
  </div>

  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
    {categories.slice(0, 6).map((category) => (
      <Link 
        key={category._id} 
        to={`/products/${slugify(category.name)}`}
        className="group relative aspect-square rounded-2xl overflow-hidden cursor-pointer"
      >
        <img 
          src={category.image} 
          alt={category.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-white font-['Poppins'] font-semibold text-lg">
            {category.name}
          </h3>
          <p className="text-white/80 font-['Poppins'] text-xs mt-1 group-hover:text-lilac-400 transition-colors">
            Shop Now →
          </p>
        </div>
      </Link>
    ))}
  </div>

  {/* VIEW ALL BUTTON */}
  {categories.length > 6 && (
    <div className="text-center mt-8">
      <Link
        to="/products"
        className="inline-block px-6 py-3 bg-lilac-400 text-white rounded-full font-['Poppins'] text-sm font-medium hover:bg-lilac-300 transition"
      >
        View All Categories →
      </Link>
    </div>
  )}
</section>

  );
}
